import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=d8a7f31c&scoped=true&"
import script from "./StudentEdit.vue?vue&type=script&lang=js&"
export * from "./StudentEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=d8a7f31c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a7f31c",
  null
  
)

export default component.exports